import {useFormik} from "formik";
import FormikInput from "../../components/FormikInput";
import {DatePicker} from "react-advance-jalaali-datepicker";
import {useContext, useEffect, useState} from "react";
import {MyContext} from "../../context/myContext";
import {EnglishToPersian, PersianToEnglish} from "numeral-convert";
import FormFooter from "../../components/FormFooter";
import moment from "moment-jalaali";
import {useDispatch, useSelector} from "react-redux";
import {editRequest, getDriversInfo, selectDriversInfo, selectRequestIsRejected} from "./requestSlice";
import {selectRegisterBtnType} from "../common-states/commonStatesSlice";

const EditRequestForm = () => {
    const {showEditForm, handleShowForm, editFormInputs} = useContext(MyContext)
    const [date, setDate] = useState(editFormInputs.deliverDate)
    const [statusMessage, setStatusMessage] = useState({content: '', styles: {}})
    const [error, setError] = useState('')
    const dispatch = useDispatch()
    const isRejected = useSelector(selectRequestIsRejected)
    const driversInfo = useSelector(selectDriversInfo)
    const registerBtnType = useSelector(selectRegisterBtnType)

    const formik = useFormik({
        initialValues: editFormInputs,
        enableReinitialize: true,
        onSubmit: values => {
            let deliverDate = date ? moment(PersianToEnglish(date.toString()), 'jYYYY/jM/jD').format('YYYY/MM/DD') : '';
            if(registerBtnType === 'ثبت اطلاعات' && (values.driverId === '' || deliverDate === null)){
                setError('تاریخ تحویل آب و راننده باید مشخص شود!')
            }
            let commonData = {
                cost: values.cost,
                description: values.description ? values.description : null,
                driver_allocated_at_user_id: Number(localStorage.getItem('userId')),
                driver_id: registerBtnType === 'رد درخواست' ? null : values.driverId,
                scheduled_time: values.deliverTime ? values.deliverTime : null,
                scheduled_to_deliver_at: deliverDate ? deliverDate : null,
                tanker_request_id: values.code,
                water_volume: values.waterVolume
            }
            commonData = (registerBtnType === 'ثبت اطلاعات' || registerBtnType === 'ویرایش اطلاعات') ? {...commonData, is_rejected: false}
                         : registerBtnType === 'رد درخواست' ? {...commonData, is_rejected: true, is_confirmed_by_user: false} : {...commonData, is_confirmed_by_user: true};

            dispatch(editRequest({commonData, code: values.code, registerBtnType, dispatch}))
        }
    })

    const handleDateChange = (timestamp, newDate) => {
        let new_date = EnglishToPersian(newDate)
        setDate(new_date)
    }

    useEffect(() => {
        formik.resetForm()
        setError('')
        // eslint-disable-next-line
    }, [showEditForm === false])

    useEffect(() => {
        dispatch(getDriversInfo()) //For select options
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setDate(editFormInputs.deliverDate)
        let content = editFormInputs.nomadReceiveDate ? 'ثبت تحویل آب توسط کاربر' : isRejected ? 'این درخواست رد شده است' : editFormInputs.driverId ? 'اختصاص راننده انجام شده است' : 'این درخواست بررسی نشده است';
        let styles = editFormInputs.nomadReceiveDate ? {backgroundColor: 'mediumseagreen', color: 'white'} : isRejected ? {backgroundColor: 'orangered', color: 'darkred'} : editFormInputs.driverId ? {backgroundColor: 'DarkTurquoise', color: 'teal'} : {backgroundColor: 'red', color: 'darkred'};
        setStatusMessage({content, styles})
        // eslint-disable-next-line
    }, [editFormInputs])

    const inputData = [
        {name: 'population', placeholder: 'تعداد خانوار'}, {name: 'code', placeholder: 'کد پیگیری'}, {name: 'name', placeholder: 'نام درخواست دهنده'},
        {name: 'waterVolume',placeholder: 'حجم آب اختصاصی(لیتر)'}, {name: 'insuredLiveStock', placeholder: 'تعداد دام های بیمه شده'},
        {name: 'deliverTime', placeholder: 'ساعت تقریبی تحویل آب'}, {name: 'waterType', placeholder: 'نوع آب درخواستی'},
        {name: 'allocatedAt', placeholder: 'تاریخ اختصاص راننده'}, {name: 'allocatedByUser', placeholder: 'کاربر اختصاص دهنده'},
        {name: 'cost', placeholder: 'هزینه آبرسانی(ریال)'}, {name: 'nomadReceiveDate', placeholder: 'تاریخ دریافت متقاضی'},
    ]

    return(
        <form className='edit-request-form' onSubmit={formik.handleSubmit}>
            <div className='form-flex'>
                <FormikInput data={inputData} formik={formik} handleChange={formik.handleChange} formType='editReqForm' />{/*This represents 11 inputs*/}
                <div>
                    <select name='driverId' value={formik.values.driverId} onChange={formik.handleChange}>
                        <option value='' disabled>انتخاب راننده</option>
                        {driversInfo.map((item, index) => {
                            return <option value={item.id} key={index}>{item.name}</option>
                        })}
                    </select>
                    <label>راننده<span>*</span></label>
                </div>
                <div>
                    <textarea name='description' rows='1' value={formik.values.description} placeholder='توضیحات' onChange={formik.handleChange}></textarea>
                    <label>توضیحات</label>
                </div>
                <div className='datepicker-container'>
                    <DatePicker cancelOnBackgroundClick format="jYYYY/jMM/jDD" placeholder='تاریخ' preSelected={date.toString()} controlValue={true} inputTextAlign='center' customClass='datepicker' onChange={handleDateChange} />
                    <label>تعیین تاریخ تحویل آب<span>*</span></label>
                </div>
            </div>
            {error && <p className='edit-request-form-error'>{error}</p>}
            <div className='status-message' style={statusMessage.styles}>{statusMessage.content}</div>
            <MyContext.Provider value={{content: statusMessage.content, handleShowForm, registerBtn: (statusMessage.content === 'اختصاص راننده انجام شده است' ? 'ویرایش اطلاعات' : statusMessage.content === 'این درخواست بررسی نشده است' ? 'ثبت اطلاعات' : '')}}>
                <FormFooter />
            </MyContext.Provider>
        </form>
    )
}

export default EditRequestForm